import Axios from 'axios';
import GeneralAction from '../Actions/GeneralAction';
import Apis from '../Apis';
import { getHeaders } from '../../utills';
import AlertAction from '../Actions/AlertActions';

class ContactUsMiddleware {

    static ContactUs = (contactData) =>{
        return dispatch => {
            dispatch(GeneralAction.ShowLoading());
            return new Promise( async (resolve,reject)=>{
                try{
                    let formdata = new FormData();
                    formdata.append('title', contactData?.query );
                    formdata.append('message', contactData?.message );
                    const {data} = await Axios.post(
                        Apis.contactQuery, 
                        formdata,
                        {
                            headers: getHeaders()
                        }
                        );
                 if (data?.success) {
                resolve(data);   
                dispatch(GeneralAction.HideLoading());

                } else {
                 dispatch(GeneralAction.HideLoading());
                 dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
                }
                }catch (error) {
                    reject(error);
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
                    console.log(error);
                    dispatch(GeneralAction.HideLoading());
                  }
                })
            }
        }

    }


export default ContactUsMiddleware;